import { ContractTypeAPIResponse } from '@black-bear-energy/black-bear-energy-common'

type ContractTypeValues = `${ContractTypeAPIResponse}`
export function getContractTypeLabel(
  contractType: ContractTypeValues | null
): string | null {
  switch (contractType) {
    case ContractTypeAPIResponse.Lease:
      return 'Lease'
    case ContractTypeAPIResponse.PPA:
      return 'PPA'
    case ContractTypeAPIResponse.LeaseAndPPA:
      return 'PPA + Lease'
    case ContractTypeAPIResponse.EPC:
      return 'EPC'
    case ContractTypeAPIResponse.ESA:
      return 'ESA'
    default:
      return null
  }
}
